module.exports = __webpack_public_path__ + "img/07.d436cf20.jpg";